import {
  Card,
  CardContent,
  CardHeader,
} from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export const WebhookDetailsSkeleton = () => {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <div className="flex flex-col items-start gap-2 sm:flex-row">
              <Skeleton className="h-8 w-48" />
              <div className="flex gap-2">
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 self-end">
            <Skeleton className="h-9 w-24" />
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <section className="grid gap-4 lg:grid-cols-2">
          <div className="rounded-lg border border-border">
            <div className="flex items-center gap-2 border-b border-border bg-muted/50 px-4 py-3">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="space-y-4 p-4">
              <div className="grid gap-4 sm:grid-cols-2">
                {Array.from({ length: 6 }).map(
                  (_, index) => (
                    <div key={index} className="space-y-1">
                      <Skeleton className="h-3 w-20" />
                      <Skeleton className="h-4 w-32" />
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="rounded-lg border border-border">
            <div className="flex items-center gap-2 border-b border-border bg-muted/50 px-4 py-3">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div className="space-y-4 p-4">
              <div className="flex flex-wrap gap-2">
                {Array.from({ length: 8 }).map(
                  (_, index) => (
                    <Skeleton
                      key={index}
                      className="h-6 w-24 rounded-full"
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </section>
      </CardContent>
    </Card>
  )
}
